<template>
  <div class="input-group input-group-lg">
    <div class="input-group-text">
      <fa-icon :icon="faMagnifyingGlass" />
    </div>
    <input
      data-cy="mod-search-input"
      type="text"
      class="form-control"
      :placeholder="$t('landingpage/mods/search/placeholder')"
      aria-label="Search"
      :value="searchTerm"
      @input="handleInput"
    />
    <button
      v-if="searchTerm.length > 0"
      type="button"
      class="btn"
      @click="resetInput"
    >
      <fa-icon class="text-rhino" :icon="faTimes" />
    </button>
  </div>
</template>

<script lang="ts">
import { faMagnifyingGlass, faTimes } from '@fortawesome/pro-solid-svg-icons';

export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const searchTerm = ref<string>(props.value);

    const handleInput = useDebounceFn((event: InputEvent) => {
      searchTerm.value = (event.target as HTMLInputElement).value;
      emit('change', searchTerm.value);
    }, 150);

    const resetInput = () => {
      searchTerm.value = '';
      emit('change', searchTerm.value);
    };

    return {
      faMagnifyingGlass,
      faTimes,

      searchTerm,
      handleInput,
      resetInput,
    };
  },
});
</script>
